import { FC } from 'react';
import { Button, Dialog } from '@chakra-ui/react';

import { useWorkflowSession } from '~/core/shared/contexts/WorkflowSessionContext';
import { useLayoutWrap } from './contexts/layoutWrap';

export const ExitConfirmModal: FC = () => {
  const { exitConfirmModalApi } = useLayoutWrap();
  const { reset } = useWorkflowSession();

  return (
    <Dialog.Root
      onOpenChange={exitConfirmModalApi.onOpenChange}
      open={exitConfirmModalApi.open}
      role="alertdialog"
    >
      <Dialog.Backdrop />
      <Dialog.Positioner>
        <Dialog.Content>
          <Dialog.Header fontSize="lg" fontWeight="bold">
            Exit Application
          </Dialog.Header>
          <Dialog.Body pl={6} pr={6}>
            Exiting the application will discard unsaved data on the current
            page. Resume this application to continue where you left off.
          </Dialog.Body>
          <Dialog.Footer>
            <Dialog.ActionTrigger asChild>
              <Button colorPalette="gray" onClick={exitConfirmModalApi.onClose}>
                Cancel
              </Button>
            </Dialog.ActionTrigger>

            <Button
              colorPalette="primary"
              ml={3}
              onClick={() => {
                reset();
              }}
              variant="solid"
            >
              Exit
            </Button>
          </Dialog.Footer>
        </Dialog.Content>
      </Dialog.Positioner>
    </Dialog.Root>
  );
};
